import styled from 'styled-components'
import { space } from 'styled-system'

import { default as VARIABLES } from '../../themes/styles/variables'

export const ToggleCompareEventStyle = styled.div`
  /* Parent
  ------------------------------- */
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
  .removeOpacity {
    opacity: unset !important;
  }
  /* Childrens
  ------------------------------- */
  .react-switch-handle {
    border: 2px solid transparent !important;
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media only screen and (max-width: 768px) {
  }
`
